import styled from 'styled-components';

import { typographyCss } from '@creditornot/cb-ingredients';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Tabs } from '@creditornot/cb-tabs';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSetSearch } from 'common/hooks/useSetSearch';

import {
  selectionRecommendationsRouteApi,
  SelectionRecommendationsSearchRouteSchemaType,
} from '..';
import { DelistingRecommendations } from './DelistingRecommendations/DelistingRecommendations';
import { ListingRecommendations } from './ListingRecommendations/ListingRecommendations';
import { PromotionRecommendation } from './PromotionRecommendations/PromotionRecommendations';

const Title = styled.div`
  ${typographyCss.headline}
`;

const TabsContainer = styled.div`
  border-bottom: 1px solid ${color.border};
`;

export const Recommendations = () => {
  const f = useFormatMessage();

  const { activeTab = 'LISTING_RECOMMENDATIONS' } = selectionRecommendationsRouteApi.useSearch();
  const setSearch = useSetSearch<SelectionRecommendationsSearchRouteSchemaType>();

  const handleTabChange = (tabId: SelectionRecommendationsSearchRouteSchemaType['activeTab']) => {
    setSearch({
      activeTab: tabId,
      promotionsSortBy: undefined,
      delistingsSortBy: undefined,
      delistingReasons: undefined,
      listingReasons: undefined,
      vendorIds: undefined,
      venueIds: undefined,
    });
  };

  return (
    <>
      <ContentContainer>
        <Title>{f('selection_recommendations.recommendations')}</Title>
      </ContentContainer>
      <TabsContainer>
        <Tabs
          activeTabId={activeTab}
          onChange={handleTabChange}
          items={[
            {
              id: 'LISTING_RECOMMENDATIONS',
              label: f('selection_recommendations.listing'),
            },
            {
              id: 'DELISTING_RECOMMENDATIONS',
              label: f('selection_recommendations.delisting'),
            },
            {
              id: 'PROMOTION_RECOMMENDATIONS',
              label: f('selection_recommendations.promotion'),
            },
          ]}
        />
      </TabsContainer>

      <div>
        {activeTab === 'LISTING_RECOMMENDATIONS' && <ListingRecommendations />}
        {activeTab === 'DELISTING_RECOMMENDATIONS' && <DelistingRecommendations />}
        {activeTab === 'PROMOTION_RECOMMENDATIONS' && <PromotionRecommendation />}
      </div>
    </>
  );
};
